export enum ConsentFrequency {
  Always = 'Always',
  EveryDay = 'EveryDay',
  EveryWeek = 'EveryWeek',
  EveryMonth = 'EveryMonth',
  EveryYear = 'EveryYear',
  OneTime = 'OneTime',
  Undef = 'Undef',
}
